
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"#112A46","opacity":".5","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.66 13.825l-1.812-.005.62-.814a.31.31 0 00.046-.084h2.681c.136 0 .281-.002.425-.016l.011-.001a3.037 3.037 0 002.733-3.03c0-1.678-1.37-3.045-3.053-3.045h-.024a3.14 3.14 0 00-.414.031l-.33.048-.022-.05-.052-.127-.052-.112-.008-.018a4.545 4.545 0 00-4.07-2.724H10.102a4.547 4.547 0 00-4.073 2.725l-.133.306-.331-.048a3.025 3.025 0 00-.414-.03h-.023a3.053 3.053 0 00-3.053 3.045 3.038 3.038 0 002.735 3.029h.008c.136.014.27.017.43.017h3.325l-.603.791a.311.311 0 00-.05.097l-1.57-.004c-.867-.003-1.849-.005-2.712-.335-.826-.315-1.526-.955-1.971-1.803-.446-.845-.58-1.785-.38-2.65.399-1.722 2.122-3.07 3.925-3.07l.118.001c.04 0 .057-.012.233-.34.026-.049.05-.095.058-.106A5.561 5.561 0 016.621 4.36a5.633 5.633 0 011.744-1.031 5.214 5.214 0 011.811-.321c.712 0 1.413.14 2.082.414 1.223.501 2.218 1.386 2.802 2.491l.014.027h.03c.028-.002.056-.002.084-.002.835 0 1.688.283 2.402.798.72.519 1.25 1.239 1.492 2.027.518 1.686-.275 3.651-1.807 4.473-.566.305-1.23.479-2.088.549-.444.036-.896.04-1.318.04h-.21z"}}),_c('path',{attrs:{"d":"M8.922 17.581a.359.359 0 01-.172-.045.321.321 0 01-.147-.398l1.12-2.881H8.112a.337.337 0 01-.305-.186.319.319 0 01.032-.336l3.4-4.463a.337.337 0 01.27-.134.36.36 0 01.173.045c.144.08.205.247.147.398l-1.12 2.882h1.61c.132 0 .249.07.306.185a.319.319 0 01-.033.337l-3.4 4.463a.337.337 0 01-.27.134zm1.056-3.833a.34.34 0 01.282.146.32.32 0 01.035.297l-.77 1.98 2.438-3.2h-1.508a.34.34 0 01-.282-.146.32.32 0 01-.035-.297l.77-1.98-2.438 3.2h1.508z"}})])
          )
        }
      }
    